export const LogoMark = ({ className = "h-10 w-10", tone = "dark" }) =>
  tone === "dark" ? (
    <img src="/img/logo-mark.png" alt="" width="40" height="40" className={`${className} object-contain`} aria-hidden="true" />
  ) : (
    <span className={`${className} grid shrink-0 place-items-center rounded-full bg-[#F9F8F3]`} aria-hidden="true">
      <img src="/img/logo-mark.png" alt="" className="h-[78%] w-[78%] object-contain" />
    </span>
  );

export const Logo = ({ tone = "dark" }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark tone={tone} className="h-11 w-11" />
    <span className="leading-none">
      <span className={`font-display block text-[1.15rem] font-extrabold uppercase tracking-[0.04em] ${tone === "dark" ? "text-[#0f3d22]" : "text-[#F9F8F3]"}`}>
        Solitaire <span className="font-medium tracking-[0.3em] text-[0.8rem] align-middle">India</span>
      </span>
      <span className={`font-mono mt-1.5 block text-[0.58rem] tracking-[0.18em] uppercase ${tone === "dark" ? "text-[#4C6053]" : "text-[#B4C7BA]"}`}>
        People | Planet | Progress
      </span>
    </span>
  </span>
);
